import React from 'react';

import { useTheme } from '@hooks';
import { Themes } from '@models';

import immunoSEQLoader from '@assets/images/immunoSEQ.gif';
import clonoSEQLoader from '@assets/images/clonoSEQ.gif';

import './Loader.scss';

export const Loader: React.FC = () => {
  const theme = useTheme();

  return (
    <div className='page-loading'>
      <img
        src={
          theme === Themes.ClonoSEQ
            ? clonoSEQLoader
            : theme === Themes.ImmunoSEQ
            ? immunoSEQLoader
            : ''
        }
        alt=''
      />
    </div>
  );
};
